export default class ProofUrlResponse {
	Type: string
	PdfUrl: string
	constructor() {
		this.Type = ""
		this.PdfUrl = ""
	}
}
